// icons svg images
import alert from "../assets/icons/alert.svg";
import bell from "../assets/icons/bell.svg";
import bills from "../assets/icons/bills.svg";
import budget from "../assets/icons/budget.svg";
import card from "../assets/icons/card.svg";
import check from "../assets/icons/check.svg";
import empty_check from "../assets/icons/empty_check.svg";
import gears from "../assets/icons/gears.svg";
import home from "../assets/icons/home.svg";
import menu from "../assets/icons/menu.svg";
import plane from "../assets/icons/plane.svg";
import plus from "../assets/icons/plus.svg";
import report from "../assets/icons/report.svg";
import search from "../assets/icons/search.svg";
import user from "../assets/icons/user.svg";
import wallet from "../assets/icons/wallet.svg";
import wealth from "../assets/icons/wealth.svg";

// person images
import person_one from "../assets/images/person_one.jpg";
import person_two from "../assets/images/person_two.jpg";
import person_three from "../assets/images/person_three.jpg";
import person_four from "../assets/images/person_four.jpg";

export const iconsImgs = {
    alert, bell, bills, budget, card, check, empty_check, gears, home, menu, plane, plus, report, search, user, wallet, wealth
}

export const personsImgs = {
    person_one, person_two, person_three, person_four
};

